import { useTranslation } from 'react-i18next';
import InputLabel from 'components/others/InputLabel';
import type { UserTabProps } from '../../types';

const accessFields = [
    { field: 'prodEdit', labelKey: 'Users.accessProdEdit' },
    { field: 'objectCreate', labelKey: 'Users.accessObjectCreate' },
    { field: 'proposalCreate', labelKey: 'Users.accessProposalCreate' },
    { field: 'warehouseOps', labelKey: 'Users.accessWarehouseOps' },
    { field: 'reportsView', labelKey: 'Users.accessReportsView' },
    { field: 'teamsEdit', labelKey: 'Users.accessTeamsEdit' },
    { field: 'tasksViewAll', labelKey: 'Users.accessTasksViewAll' },
] as const;

const UserTabAccessManager = ({ user, dispatchUser }: UserTabProps) => {
    const { t } = useTranslation();

    if (user?.admin) return null;

    return (
        <>
            {accessFields.map(({ field, labelKey }) => (
                <div className="form-check form-switch" key={field}>
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id={field}
                        checked={!!user?.access?.[field]}
                        onChange={(e) => {
                            dispatchUser({
                                type: 'SET_ACCESS_FIELD',
                                field,
                                value: e.currentTarget.checked,
                            });
                        }}
                    />
                    <InputLabel title={t(labelKey)} htmlFor={field} rightElement={null} children={null} />
                </div>
            ))}
        </>
    );
};

export default UserTabAccessManager;
